import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ClientsService } from 'src/app/services/clients.service';

@Component({
    selector: 'app-clients-sidebar',
    templateUrl: './clients-sidebar.component.html',
    styleUrl: './clients-sidebar.component.scss',
    standalone: false
})
export class ClientsSidebarComponent {
	@Input() clients: any[] = [];
	@Output() showSidebarEvent = new EventEmitter();

	constructor(private clientsService: ClientsService) {}

	goToClient(item: any) {
		this.clientsService.setClient(item);
	}

	closeSideBar(){
    this.showSidebarEvent.emit(false);
  }
}
